export default __webpack_public_path__ + "static/media/revenue.8b121260.svg";